var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShortClassic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 60,
    viewBox: "0 0 80 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.9784 18.8277C59.8993 8.57533 19.8663 9.55174 13.7637 18.8277V24.4421C13.7637 25.1744 26.213 36.6473 26.4571 37.1355C26.6524 37.5261 51.2743 36.3218 63.5609 35.6709L66.9784 18.8277Z",
    fill: "white",
    stroke: "#999999",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0655 44.7028C43.9787 50.2811 38.2977 50.1862 27.1904 44.7028L39.3956 32.4976H41.3485L53.0655 44.7028Z",
    fill: "white",
    stroke: "#999999",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2373 27.6152C37.4944 25.5724 43.9923 25.6237 55.018 27.6152",
    stroke: "#999999",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5283 49.0965C11.7827 46.4666 8.63798 42.7498 4 36.4031C7.11033 28.978 9.61439 24.442 13.7642 18.8276C20.4015 26.0969 25.5526 28.6483 39.3951 32.4975L23.5283 49.0965Z",
    fill: "white",
    stroke: "#999999",
    strokeWidth: 3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2148 49.0965C68.0958 45.4949 71.2774 41.7909 76.7432 36.4031C73.6328 28.978 71.1288 24.442 66.979 18.8276C60.3417 26.0969 55.1905 28.6483 41.3481 32.4975L57.2148 49.0965Z",
    fill: "white",
    stroke: "#999999",
    strokeWidth: 3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8254 42.486C41.3423 43.472 40.2965 43.8359 39.5413 43.4658C38.7862 43.0958 38.4329 42.0463 38.9161 41.0604C39.3993 40.0744 40.4451 39.7105 41.2002 40.0806C41.9554 40.4506 42.3086 41.5001 41.8254 42.486Z",
    fill: "#999999",
    stroke: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShortClassic);
export default __webpack_public_path__ + "static/media/short_classic.ec6dc2c1c6b303a5e569aa56e449d6ce.svg";
export { ForwardRef as ReactComponent };